import { reactive } from "vue";
import umfApi from "./apiController.js";
import Vue from "vue";
import { i18n } from '../main'

export default reactive({
    data: {},
    loading: {},

    async apiCall(method, endpoint, params = undefined, data = undefined) {
        const entity = endpoint.split("/").pop()
        Vue.set(this.loading, entity, true)
        let response;
        try {
            if (["get", "delete"].includes(method)) {
                response = await umfApi[method](endpoint, params);
            } else {
                response = await umfApi[method](endpoint, undefined, data);
            }
        } catch (error) {
            console.error(error);
            Vue.notify({
                group: "crudTable",
                type: "error",
                text: i18n.t('crudError', [entity]),
            });
        }
        Vue.set(this.loading, entity, false)
        return response;
    },

    async getItems(endpoint) {
        Vue.set(this.data, endpoint.split("/").pop(), []);
        const response = await this.apiCall("get", endpoint);
        if (response && response.data) {
            Vue.set(this.data, endpoint.split("/").pop(), response.data);
            return this.data[endpoint.split("/").pop()];
        }
    },

    async createItem(endpoint, item) {
        const response = await this.apiCall("post", endpoint, undefined, item);
        if (response && response.data) {
            this.data[endpoint.split("/").pop()].push(response.data);
            Vue.notify({
                group: "crudTable",
                type: "success",
                text: i18n.t('crudCreated', [i18n.t(endpoint.split("/").pop().slice(0, -1))]),
            });
        }
    },

    async modifyItem(endpoint, item) {
        const entity = endpoint.split("/").pop();
        const { id, ...itemWithoutId } = item;

        await this.apiCall(
            "put",
            `${endpoint}/${id}`,
            undefined,
            itemWithoutId
        );

        const oldValueIndex = this.data[entity].findIndex(
            (item) => item.id == id
        );
        if (oldValueIndex != -1) {

            Vue.set(this.data[entity], oldValueIndex, item)

            Vue.notify({
                group: "crudTable",
                type: "success",
                text: i18n.t('crudModified', [i18n.t(entity.slice(0, -1))]),
            });
        }
    },

    async deleteItem(endpoint, id) {
        await this.apiCall("delete", `${endpoint}/${id}`);
        const newData = this.data[endpoint.split("/").pop()].filter((col) => col.id != id);
        Vue.set(this.data, endpoint.split("/").pop(), newData);
        Vue.notify({
            group: "crudTable",
            type: "success",
            text: i18n.t('crudDeleted', [i18n.t(endpoint.split("/").pop().slice(0, -1))]),
        });
    },
});
